import React, { useEffect, useRef } from 'react';
import { ButtonEdge } from '../../../components/buttonsOg';
import { useState } from 'react';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

function EnrollmentInfo() {
    return (
        <div className="flex gap-1.5 items-center self-center px-2.5 py-1.5 text-center text-gray-800 whitespace-nowrap bg-neutral-50 rounded-[40px]">
            <div className=' flex '>
                <img
                    loading="lazy"
                    src="/assets/temp/student_avatar.png"
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto aspect-[3.48] h-7 w-7"
                />
                <img
                    loading="lazy"
                    src="/assets/temp/student_avatar_2.png"
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto aspect-[3.48] h-7 w-7 ml-[-8px]"
                />
                <img
                    loading="lazy"
                    src="/assets/temp/student_avatar.png"
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto aspect-[3.48] h-7 w-7 ml-[-8px]"
                />
                <img
                    loading="lazy"
                    src="/assets/temp/student_avatar_2.png"
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto aspect-[3.48] h-7 w-7 ml-[-8px]"
                />
                <img
                    loading="lazy"
                    src="/assets/temp/student_avatar_2.png"
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto aspect-[3.48] h-7 w-7 ml-[-8px]"
                />
            </div>
            {/* <div className=' bg-yellow-500 h-7 w-7 rounded-full'></div> */}
            <div className="self-stretch my-auto text-base tracking-tight leading-7 rotate-[-0.0030319990213347105rad]">
                +
            </div>
            <div className="flex gap-0.5 items-start self-stretch my-auto font-medium h-[18px] rotate-[-0.0030319990213347105rad] w-[79px]">
                <div className="text-base leading-none">40</div>
                <div className="text-sm leading-none">students</div>
            </div>
        </div>
    );
}


function CourseDetails(
    {
        course,
        CourseDescription
    }
) {
    return (
        <div className="flex flex-col w-full text-left">
            {/* <time className="mt-5 text-xs text-slate-500">1 - 28 July 2022</time> */}
            <h2 className="text-[17px] sm:text-[18px] font-bold text-[#2a1273] font-AndoraModernSerif">
                {course}
            </h2>
            {CourseDescription && (
                <p className="mt-1 text-[13px] text-gray-500 text-center line-clamp-2">
                    {CourseDescription}
                </p>
            )}
        </div>
    );
}

function PriceInfo() {
    return (
        <div className="flex gap-10 justify-between w-full items-center  mt-8">
            <div className="flex gap-2 items-center pb-2.5 my-auto w-[97px]">
                <div className="grow text-lg font-bold text-black whitespace-nowrap">$ 380</div>
                <div className="text-base text-stone-900 whitespace-nowrap">$ 500</div>
            </div>
            <ButtonEdge variant='primary' text='Enroll Now' className=' min-w-[100px]' />
        </div>
    );
}


function CourseCard({
    imgSrc,
    course,
    CourseDescription,
    modalContent
}) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleWhatsAppClick = (e) => {
        e.stopPropagation();
        const message = `Hello, I am interested in the ${course} course.`;
        const whatsappUrl = `https://wa.me/917907252303?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <>
            <article
                onClick={toggleModal}
                className="flex overflow-hidden flex-col bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-xl w-[260px] sm:w-[280px] cursor-pointer hover:-translate-y-1 transition-all duration-300 group"
            >
                <div className="w-full h-[180px] overflow-hidden bg-stone-50">
                    <img
                        loading="lazy"
                        src={imgSrc}
                        alt={course}
                        className="object-contain sm:object-cover w-full h-full transform filter group-hover:brightness-105 transition-all duration-500"
                    />
                </div>
                <div className="flex flex-col p-4 bg-white w-full">
                    {/* <EnrollmentInfo /> */}
                    <CourseDetails
                        course={course}
                        CourseDescription={CourseDescription}
                    />
                    {/* <PriceInfo /> */}
                </div>
            </article>

            {isModalOpen && (
                <div
                    className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-md p-4 sm:p-6 md:mt-[60px]"
                    onClick={toggleModal}
                >
                    <div
                        className="bg-white rounded-xl w-[98%] max-w-[1024px] shadow-2xl relative transform transition-all flex flex-col md:flex-row max-h-[82vh] md:max-h-[88vh] overflow-hidden"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={toggleModal}
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-900 text-3xl font-light transition-all z-20 bg-gray-100/50 hover:bg-gray-100 backdrop-blur-sm rounded-full w-10 h-10 flex items-center justify-center pb-1"
                        >
                            &times;
                        </button>

                        {/* Image & Title Section - Left side on MD */}
                        <div className="w-full md:w-[36%] p-3 sm:p-5 md:p-8 bg-[#faf9f6]/80 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-gray-100 flex-shrink-0 relative max-h-[25vh] md:max-h-none">
                            <div className="w-full max-w-[100px] sm:max-w-[140px] md:max-w-[280px] aspect-square rounded-xl overflow-hidden bg-white mb-2 sm:mb-3 md:mb-6 p-2 md:p-4 shadow-sm border border-gray-100 flex items-center justify-center relative">
                                <img
                                    loading="lazy"
                                    src={imgSrc}
                                    alt={course}
                                    className="w-full h-full object-contain"
                                />
                            </div>

                            <h2 className="text-[18px] sm:text-[22px] md:text-[32px] font-bold text-[#2a1273] font-AndoraModernSerif text-center leading-tight relative z-10">
                                {course}
                            </h2>
                            <div className="w-8 md:w-12 h-0.5 md:h-1.5 bg-yellow-400 mt-2 md:mt-5 rounded-full opacity-80"></div>
                        </div>

                        {/* Scrollable Content Section - Right side on MD */}
                        <div className="w-full md:w-[64%] flex flex-col bg-white min-h-0 flex-grow md:h-full md:max-h-[calc(100vh-120px)] relative overflow-hidden">
                            <div className="flex-grow overflow-y-auto px-5 sm:px-8 md:px-10 py-5 sm:py-8 md:py-8 custom-scrollbar">
                                <div className="text-gray-600 text-[16px] w-full mx-auto">
                                    {modalContent || (
                                        <div className="leading-relaxed text-center py-10">
                                            {CourseDescription || "Discover the depths of knowledge in this exclusive program tailored for dedicated learners. Equip yourself with essential skills and insights, and become part of a profound educational journey. Click below to inquire further or enroll today."}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="px-6 md:px-10 py-4 border-t border-gray-100 bg-white shadow-[0_-5px_20px_rgba(0,0,0,0.01)] flex flex-col sm:flex-row justify-between items-center gap-3 flex-shrink-0 z-10 relative">
                                <div className="text-[13px] font-medium text-gray-400 hidden sm:block">
                                    Got questions? Connect with our mentors
                                </div>
                                <button
                                    onClick={handleWhatsAppClick}
                                    className="bg-[#25D366] hover:bg-[#1fae54] text-white font-medium py-2.5 px-6 flex items-center justify-center gap-2 transition-all duration-300 shadow-[0_4px_10px_rgba(37,211,102,0.2)] hover:shadow-[0_6px_15px_rgba(37,211,102,0.3)] rounded-full hover:-translate-y-0.5 w-full sm:w-auto text-[14px]"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 1.905 6.456L.044 24l5.656-1.516A11.928 11.928 0 0 0 11.944 24a12 12 0 0 0 12-12 12 12 0 0 0-12-12zM19.125 17.062c-.31.875-1.503 1.637-2.31 1.776-.66.113-1.506.26-4.298-.898-3.376-1.4-5.548-4.834-5.717-5.06-.168-.225-1.365-1.815-1.365-3.46 0-1.646.85-2.457 1.157-2.772.31-.314.67-.393.89-.393.222 0 .445 0 .633.008.203.01.472-.078.736.56.28.673.948 2.316 1.033 2.484.084.17.142.368.03.593-.113.225-.17.368-.34.565-.168.196-.353.418-.507.575-.168.168-.346.353-.146.697.198.344.887 1.467 1.91 2.38 1.316 1.176 2.42 1.543 2.766 1.71.346.168.552.142.758-.084.207-.225.885-1.03 1.127-1.383.243-.353.485-.295.803-.17.318.12 2.016.947 2.363 1.124.346.177.577.265.66.41.084.148.084.872-.224 1.745z" />
                                    </svg>
                                    Connect on WhatsApp
                                </button>
                            </div>
                        </div>
                    </div>
                </div >
            )
            }
        </>
    );
}
function CourseCategoryCarousel() {
    const scrollContainerRef = useRef(null);
    const [isAtStart, setIsAtStart] = useState(true);

    const khairaModalContent = (
        <div className="text-left font-sans text-gray-700 leading-relaxed pb-4 space-y-7">
            {/* Header Section */}
            <div className="border-b border-gray-100 pb-5">
                <h3 className="font-bold text-xl text-[#2a1273] mb-2 flex items-center gap-2">
                    <span className="text-2xl">🏫</span> ദാറുൽ ഹദീസ് അൽ ഇസ്ലാമിയ്യ
                </h3>
                <p className="text-[14px] text-gray-600 leading-loose">മുത്ത് നബിﷺ തങ്ങളുടെ ഹദീസുകളിൽ ഗവേഷണം നടത്തുക, സാധാരണക്കാരിലേക്കും എത്തുന്ന രീതിയിൽ ഹദീസ് പഠനം വ്യാപിപ്പിക്കുക എന്നീ ലക്ഷ്യങ്ങളോടെ ഓഫ്ലൈനിലും ഓൺലൈനിലുമായി പ്രവർത്തിക്കുന്ന കേരളത്തിലെ ആദ്യത്തെ ഹദീസ് റിസർച്ച് സെൻ്റർ.</p>
            </div>

            {/* Diploma Section */}
            <div>
                <h3 className="font-semibold text-lg text-gray-900 flex items-center gap-2 mb-3">
                    <span className="text-yellow-600 text-xl">🎓</span> SIHAH Diploma in Hadees Research
                </h3>
                <p className="text-gray-600 mb-5 text-[14px]">ദാറുൽ ഹദീസ് അൽ ഇസ്ലാമിയക്ക് കീഴിൽ സ്ത്രീകൾക്ക് ഹദീസ് പഠനം സാധ്യമാക്കാൻ ഓൺലൈനിലായി സജീകരിക്കപ്പെട്ടതാണ് <span className="font-bold text-[#2a1273]">Sihah</span>.</p>

                <ul className="space-y-4 text-[14px] pl-1">
                    <li className="flex gap-3">
                        <span className="text-[#2a1273] mt-1 shrink-0">🔹</span>
                        <div>
                            <span className="font-semibold text-gray-900 block mb-1">ഹദീസ് പഠനം</span>
                            <span className="text-gray-500 block leading-relaxed">വിശ്വപ്രസിദ്ധ ഹദീസ് ഗ്രന്ഥം സ്വഹീഹുൽബുഖാരി യിൽ നിന്ന് തെരഞ്ഞെടുത്ത 50 ഹദീസുകളെ അടിസ്ഥാനപ്പെടുത്തി സ്ത്രീകളുടെ കുടുംബ ജീവിതം , പാരൻ്റിംഗ് ,ഇസ്ലാമിക് ലൈഫ് സ്റ്റൈൽ, ആദർശം തുടങ്ങിയവ ചർച്ച ചെയ്യുന്നതാണ് പ്രധാന ഭാഗം.</span>
                        </div>
                    </li>
                    <li className="flex gap-3">
                        <span className="text-[#2a1273] mt-1 shrink-0">🔹</span>
                        <div>
                            <span className="font-semibold text-gray-900 block mb-1">കർമ്മശാസ്ത്രം</span>
                            <span className="text-gray-500 block">സ്ത്രീകളുമായി ബന്ധപ്പെട്ടതും സുപ്രധാനവുമായ വിഷയങ്ങളിൽ കർമ്മശാസ്ത്ര പഠന ക്ലാസ്.</span>
                        </div>
                    </li>
                    <li className="flex gap-3">
                        <span className="text-[#2a1273] mt-1 shrink-0">🔹</span>
                        <div>
                            <span className="font-semibold text-gray-900 block mb-1">തജ് വീദ്</span>
                            <span className="text-gray-500 block">ഫാത്തിഹ അടക്കം ചെറിയ സൂറത്തുകളെ അടിസ്ഥാനമാക്കി തജ് വീദ് ക്ലാസുകൾ.</span>
                        </div>
                    </li>
                    <li className="flex gap-3">
                        <span className="text-[#2a1273] mt-0.5 shrink-0">🔹</span>
                        <span className="font-semibold text-gray-900 block">ഇസ്ലാമിക് ലൈഫ് സ്റ്റൈൽ, ഹുബ്ബുന്നബി ചരിത്ര പഠനം</span>
                    </li>
                </ul>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-3">
                <div>
                    <h3 className="font-semibold text-[15px] text-gray-900 mb-2 flex items-center gap-2"><span className="text-blue-500">🔖</span> എങ്ങനെയായിരിക്കും കോഴ്സ്?</h3>
                    <p className="text-gray-500 leading-relaxed text-[13px]">റെക്കോർഡ് ചെയ്ത യുട്യൂബ് വീഡിയോകൾ വഴിയായിരിക്കും ക്ലാസുകൾ നടക്കുക. ആഴ്ചയിൽ നാല് ക്ലാസുകൾ. ആഴ്ചയിൽ ഒരു കർമശാസ്ത്ര ക്ലാസ്, രണ്ടാഴ്ച കൂടുമ്പോൾ തജ്വീദ് ക്ലാസ് എന്നിവ നടക്കും.</p>
                </div>

                <div>
                    <h3 className="font-semibold text-[15px] text-gray-900 mb-2 flex items-center gap-2"><span className="text-purple-500">📚</span> Duration & Fee</h3>
                    <p className="text-gray-500 leading-relaxed text-[13px]">പത്ത് മാസമാണ് കോഴ്സ് കാലാവധി. 5 മാസം വീതമുള്ള രണ്ട് സെമസ്റ്ററുകൾ. ഓരോ സെമസ്റ്ററിലും പരീക്ഷകൾ നടത്തും.</p>
                    <p className="mt-2 text-[14px] font-semibold text-[#2a1273]">500 രൂപയാണ് ആകെ കോഴ്സ് ഫീ</p>
                </div>
            </div>

            <div className="bg-red-50/50 p-4 rounded-xl border border-red-100/50">
                <h3 className="font-semibold text-[15px] text-red-700 mb-1 flex items-center gap-2">
                    <span>✨</span> ഉംറയും സിയാറത്തും!
                </h3>
                <p className="text-red-900/80 text-[13px]">2 സെമസ്റ്റർ എക്സാമുകളിൽ നിന്നുമായി ഒന്നാം സ്ഥാനം നേടുന്ന പഠിതാവിന് ഉംറയും മദീനാ സിയാറത്തും സമ്മാനമായി നൽകുന്നു.</p>
            </div>

            <div className="flex items-start gap-3">
                <div className="text-xl shrink-0 mt-0.5">👤</div>
                <div>
                    <h3 className="font-semibold text-[15px] text-gray-900 mb-1">മെൻ്റേഴ്സ്</h3>
                    <p className="text-gray-500 text-[13px]">ഓരോ വിദ്യാർത്ഥിക്കും ദാറുൽ ഹദീസ് D.MET കോഴ്സ് പൂർത്തിയാക്കിയ വനിതാ മെൻ്റർമാർ</p>
                </div>
            </div>

            <div className="pt-4 border-t border-gray-100">
                <h3 className="font-bold text-lg text-[#2a1273] mb-3">ഖൈറ</h3>
                <div className="space-y-3 text-gray-500 leading-relaxed text-[13px]">
                    <p>സ്വഹാബി പ്രമുഖരായ അബൂദർദാഅ് (റ) വിൻ്റെ ഭാര്യയാണ് <span className="font-semibold text-gray-900 border-b border-gray-200">ഖൈറ ബീവി (റ:അ)</span>.</p>
                    <p>മുത്ത് നബി ﷺ തങ്ങളിൽ നിന്നും തൻ്റെ ഭർത്താവായ അബൂദർദാഅ് (റ) ൽ നിന്നും ഹദീസുകൾ റിപ്പോർട്ട് ചെയ്ത മഹതിയാണ്. ചരിത്ര ഗ്രന്ഥങ്ങളെല്ലാം തന്നെ വലിയ ബുദ്ധിമതിയും, സ്ത്രീകളിൽ സ്രേഷ്ടയാണെന്നും സാക്ഷ്യപ്പെടുത്തിയ മഹോന്നത പദവിയിലുള്ള സ്വഹാബി വനിതയാണ് ഖൈറ ബീവി (റ:അ).</p>
                    <p>മദീനയിൽ ജീവിത കാലം ചിലവഴിച്ച വനിതാ രത്നം, ഉസ്മാൻ (റ) ൻ്റെ ഭരണ കാലത്ത് ശാമിൽ വെച്ചാണ് ഈ ലോകത്തോട് വിട പറഞ്ഞത്.</p>
                </div>
            </div>

            <div className="py-4 border-y border-gray-100 text-center">
                <p className="italic text-gray-500 leading-relaxed text-[13px] px-2">
                    "മുത്ത് നബി ﷺ തങ്ങളുടെ ഹദീസുകളെ വിശദമായി പഠിക്കാനും, അതിൻ്റെ പ്രചാരകരാകാനും തയ്യാറായ Sihah പഠിതാക്കൾക്ക് നൽകുന്ന സനദിന് ഉചിതമായ നാമം അനുപമ വ്യക്തിത്വത്തിന് ഉടമയായ ഖൈറ ബീവി (റ:അ) യുടേതാണെന്ന് ദാറുൽ ഹദീസ് ഉറച്ച് വിശ്വസിക്കുന്നു."
                </p>
            </div>

            <div className="bg-green-50/50 p-4 rounded-xl border border-green-100/50 text-center">
                <p className="font-medium text-green-800 text-[13px] leading-relaxed">
                    Sihah Diploma in Hadees Research കോഴ്സ് പൂർത്തിയാക്കി 2 സെമസ്റ്റർ എക്സാമുകളിലും വിജയികളാകുന്നവർക്ക് ഇസ്ലാമിക് ഡിപ്ലോമ ഇൻ ഹദീസ് റിസേർച്ച് സർട്ടിഫിക്കറ്റും, ഖൈറ ബിരുദവും നൽകപ്പെടുന്നതാണ്.
                </p>
            </div>
        </div>
    );

    const sunnaModalContent = (
        <div className="text-left font-sans text-gray-700 leading-relaxed pb-4 space-y-7">
            {/* Header Section */}
            <div className="border-b border-gray-100 pb-5">
                <h3 className="font-bold text-xl text-[#2a1273] mb-2 flex items-center gap-2">
                    <span className="text-2xl">🏫</span> ദാറുൽ ഹദീസ് അൽ ഇസ്ലാമിയ്യ
                </h3>
                <p className="text-[14px] text-gray-600 leading-loose">മുത്ത് നബിﷺ തങ്ങളുടെ ഹദീസുകളിൽ ഗവേഷണം നടത്തുക, സാധാരണക്കാരിലേക്കും എത്തുന്ന രീതിയിൽ ഹദീസ് പഠനം വ്യാപിപ്പിക്കുക എന്നീ ലക്ഷ്യങ്ങളോടെ ഓഫ്ലൈനിലും ഓൺലൈനിലുമായി പ്രവർത്തിക്കുന്ന കേരളത്തിലെ ആദ്യത്തെ ഹദീസ് റിസർച്ച് സെൻ്റർ.</p>
            </div>

            {/* Course Information Section */}
            <div>
                <h3 className="font-semibold text-lg text-gray-900 flex items-center gap-2 mb-3">
                    <span className="text-yellow-600 text-xl">💡</span> എന്താണ് ഈ ആദർശ കോഴ്സ്?
                </h3>
                <p className="text-gray-600 mb-5 text-[14px]">സുന്നി വിശ്വാസധാരയുടെ അടിസ്ഥാനപരമായ ആശയാദർശങ്ങളും ആവാന്താര വിഭാഗങ്ങളുടെ പുത്തൻ വാദങ്ങളും അതിനുള്ള മറുപടികളും വിശദമായി അറിയാനും പഠിക്കാനും ആഗ്രഹിക്കുന്നവർക്കുള്ള ഓൺലൈൻ കോഴ്സ്.</p>
            </div>

            <div className="flex items-start gap-3 bg-blue-50/30 p-4 rounded-xl border border-blue-50/50">
                <div className="text-xl shrink-0 mt-0.5">👥</div>
                <div>
                    <h3 className="font-semibold text-[15px] text-gray-900 mb-1">ആർക്കെല്ലാം ജോയിൻ ചെയ്യാം?</h3>
                    <p className="text-gray-500 text-[13px] leading-relaxed">സുന്നത്ത് ജമാഅത്തിന്റെ ആദർശം പഠിക്കാൻ ആഗ്രഹിക്കുന്ന സ്വദേശത്തും വിദേശത്തുമുള്ള സ്ത്രീ-പുരുഷ-പ്രായഭേദമന്യേ എല്ലാവർക്കും ചേരാം.</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-3">
                <div>
                    <h3 className="font-semibold text-[15px] text-gray-900 mb-2 flex items-center gap-2"><span className="text-blue-500">📱</span> ക്ലാസിന്റെ രൂപം</h3>
                    <p className="text-gray-500 leading-relaxed text-[13px]">അഡ്മിഷൻ പൂർത്തിയാകുമ്പോൾ നിങ്ങൾ ആഡ് ചെയ്യപെടുന്ന ഗ്രൂപ്പിൽ വരുന്ന യൂട്യൂബ് ലിങ്ക് വഴി ക്ലാസുകൾ കേൾക്കാം. ആഴ്ചയിൽ 5 ക്ലാസുകൾ ഉണ്ടായിരിക്കും.</p>
                </div>

                <div>
                    <h3 className="font-semibold text-[15px] text-gray-900 mb-2 flex items-center gap-2"><span className="text-green-500">💵</span> ഫീസ് ഉണ്ടോ?</h3>
                    <p className="text-gray-500 leading-relaxed text-[13px] mb-2">കോഴ്സുമായി ബന്ധപ്പെട്ട് ഒരു തരത്തിലുള്ള ഫീസും ഈടാക്കുന്നതല്ല.</p>
                    <div className="inline-block bg-green-50 text-green-700 border border-green-200 font-semibold px-3 py-1 rounded text-[13px]">സൗജന്യ കോഴ്സ് ⚠️</div>
                </div>
            </div>

            <div className="pt-4 border-t border-gray-100">
                <h3 className="font-bold text-lg text-[#2a1273] mb-3 flex items-center gap-2">
                    <span>📅</span> കോഴ്സ് സ്ട്രെക്ചർ
                </h3>
                <div className="space-y-3 text-gray-500 leading-relaxed text-[13px]">
                    <p>ഒരു വർഷം ആണ് കോഴ്സ് ടൈം, ശവാലിൽ ആരംഭിച് റജബിൽ അവസാനിക്കുന്നു. ശേഷം എക്സാം. ക്ലാസുകളും എക്സാമും അടക്കം പൂർണമായും ഓൺലൈൻ ആയിരിക്കും.</p>
                </div>
            </div>

            <div className="bg-red-50/50 p-4 rounded-xl border border-red-100/50 mt-4">
                <h3 className="font-semibold text-[15px] text-red-700 mb-1 flex items-center gap-2">
                    <span>✨</span> ഉംറയും സിയാറത്തും!
                </h3>
                <p className="text-red-900/80 text-[13px]">എക്സാമിൽ ഒന്നാം സ്ഥാനം ലഭിക്കുന്നവർക്ക് ഉംറ ചെയ്യാനുള്ള അവസരം സമ്മാനമായി നൽകുന്നു.</p>
            </div>
        </div>
    );

    const juniorAcademyModalContent = (
        <div className="text-left font-sans text-gray-700 leading-relaxed pb-4 space-y-7">
            {/* Header Section */}
            <div className="border-b border-gray-100 pb-5">
                <h3 className="font-bold text-xl text-[#2a1273] mb-2 flex items-center gap-2">
                    <span className="text-2xl">🏫</span> DARUL HADEES JUNIOR ACADEMY
                </h3>
                <p className="text-[13px] text-gray-500 font-medium tracking-wide">(VENGARA)</p>
            </div>

            {/* Admission Section */}
            <div className="bg-yellow-50/50 p-5 rounded-xl border border-yellow-200/50 text-center">
                <h3 className="font-bold text-lg text-yellow-800 mb-1">New Admission</h3>
                <p className="text-yellow-900/70 text-[14px] font-medium">(സ്കൂൾ 7 കഴിഞ്ഞ കുട്ടികൾക്ക് 8-ാം ക്ലാസിലേക്ക് അഡ്മിഷൻ)</p>
            </div>

            {/* Features List Section */}
            <div className="space-y-4">
                <h3 className="font-semibold text-lg text-gray-900 flex items-center gap-2 mb-4">
                    <span className="text-blue-600 text-xl">✨</span> അക്കാദമിക് പ്രത്യേകതകൾ
                </h3>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {[
                        "ജാമിഅഃതുൽ ഹിന്ദ് സിലബസ്",
                        "പ്രമുഖരുൾപ്പെടുന്ന അക്കാദമിക് ബോഡി",
                        "വിസിറ്റിംഗ് ഫാക്കൽറ്റികൾ ഉൾപ്പെടെ പ്രഗൽഭരായ ഉസ്താദുമാരുടെ ക്ലാസുകൾ",
                        "ക്യാമ്പസിനകത്തു തന്നെ സ്കൂൾ സൗകര്യം",
                        "വിശാലമായ ലൈബ്രറി ഖുതുബുഖാന സംവിധാനം",
                        "ആദർശം, നവീനവാദ മേഖലകളിൽ പ്രത്യേക പഠനം",
                        "ഫോറിൻ ലാംഗ്വേജസ്, കോമ്പറ്ററ്റീവ് എക്സാമിനേഷൻസ് പരിശീലനം",
                        "പ്രഭാഷണം, ഗ്രന്ഥ രചന എന്നിവയിൽ പരിശീലനം",
                        "ആധുനിക സൗകര്യങ്ങളോടുകൂടിയുള്ള ക്ലാസ്സ് റൂം, ഹോസ്റ്റൽ"
                    ].map((feature, idx) => (
                        <li key={idx} className="flex gap-3 items-start p-3 bg-gray-50/50 rounded-lg border border-gray-100/50">
                            <span className="text-[#2a1273] mt-1 shrink-0 text-xs">●</span>
                            <span className="text-gray-600 text-[13px] leading-relaxed">{feature}</span>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Leadership Section */}
            <div className="pt-6 border-t border-gray-100">
                <div className="flex items-center gap-4 bg-[#2a1273]/[0.02] p-4 rounded-xl border border-[#2a1273]/5">
                    <div className="w-12 h-12 bg-white shadow-sm rounded-full flex items-center justify-center text-2xl shrink-0">👤</div>
                    <div>
                        <h3 className="font-bold text-[#2a1273] text-[15px] mb-0.5">നേതൃത്വം</h3>
                        <p className="text-gray-900 font-semibold text-[14px]">ഉസ്താദ് ഒ.പി മുസ്തഫ സഖാഫി വേങ്ങര</p>
                    </div>
                </div>
            </div>
        </div>
    );
    const [isAtEnd, setIsAtEnd] = useState(false);

    const checkScrollPosition = () => {
        const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
        setIsAtStart(scrollLeft === 0);
        setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
    };

    const handlePrev = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -300,
                behavior: 'smooth',
            });
        }
    };

    const handleNext = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 300,
                behavior: 'smooth',
            });
        }
    };

    useEffect(() => {
        const container = scrollContainerRef.current;
        checkScrollPosition(); // Check initially
        container.addEventListener('scroll', checkScrollPosition);

        return () => container.removeEventListener('scroll', checkScrollPosition);
    }, []);

    return (
        <div className='relative'>
            <div
                className='no-scrollbar overflow-x-scroll w-full scrollbar-hide md:overflow-x-auto md:scroll-smooth  z-10 mt-16 pb-16'
                ref={scrollContainerRef}
            >
                <div className='flex gap-7 w-min mx-auto relative z-10 px-9 sm:px-20'>
                    <CourseCard
                        imgSrc={'/assets/courses/kaira.jpeg'}
                        course={'Sihah-Khaira'}
                        CourseDescription={''}
                        modalContent={khairaModalContent}
                    />
                    <CourseCard
                        imgSrc={'/assets/courses/sunna.jpeg'}
                        course={'ആദർശ കോഴ്സ്'}
                        CourseDescription={''}
                        modalContent={sunnaModalContent}
                    />
                    <CourseCard
                        imgSrc={'/assets/courses/cou.jpeg'}
                        course={'ജൂനിയർ അക്കാദമി'}
                        CourseDescription={''}
                        modalContent={juniorAcademyModalContent}
                    />
                </div>
            </div>
            {!isAtStart && (
                <button
                    className='top-1/2 -translate-y-1/2 absolute z-10 left-5 rounded-full px-3 py-3 bg-pumpkinToast-500  shadow-md flex items-center'
                    onClick={handlePrev}
                >
                    <IconChevronLeft className='text-white text-2xl' />
                </button>
            )}
            {!isAtEnd && (
                <button
                    className='top-1/2 -translate-y-1/2 absolute z-10 right-5 rounded-full px-3 py-3 bg-pumpkinToast-500  shadow-md flex items-center'
                    onClick={handleNext}
                >
                    <IconChevronRight className='text-white text-2xl' />
                </button>
            )}
        </div>
    );
}

export { CourseCategoryCarousel };
